// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 파일명: AppStoryManage.css */

.story-manage {
    width: 100%;
}

.story-manage-title {
    color: white;
    margin-bottom: 24px;
}

/* 이야기 등록 */
.story-form {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 24px;
}

.story-textarea {
    width: 100%;
    min-height: 100px;
    padding: 14px;
    border-radius: 12px;
    border: 1px solid
            rgba(255,255,255,.1);
    background:
            rgba(255,255,255,.05);
    color: white;
    resize: vertical;
}

.story-save-button {
    height: 48px;
    border: none;
    border-radius: 12px;
    background:
            linear-gradient(
                    135deg,
                    #6f3cff,
                    #2d9cff
            );
    color: white;
    font-size: 14px;
    cursor: pointer;
}

/* 이야기 리스트 */
.story-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.story-card {
    padding: 20px;
    border-radius: 20px;
    background:
            rgba(255,255,255,.04);
    border:
            1px solid rgba(
                    255,
                    255,
                    255,
                    .08
            );
}

.story-header {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.story-content-text {
    white-space: pre-wrap;
    word-break: break-word;
    color: rgba(255,255,255,.9);
    font-size: 14px;
    line-height: 1.5;
}

.story-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.story-edit-button,
.story-delete-button,
.story-comment-button {
    border: none;
    border-radius: 10px;
    padding: 8px 14px;
    font-size: 13px;
    color: white;
    cursor: pointer;
}

.story-edit-button {
    background: #2d9cff;
}

.story-delete-button {
    background: #ff4d67;
}

.story-comment-button {
    background: #ff9800;
}

/* 댓글 영역 */
.story-comment-section {
    margin-top: 14px;
    padding-top: 12px;
    border-top: 1px solid
            rgba(255,255,255,.08);
}

.story-comment-title {
    font-size: 14px;
    margin-bottom: 10px;
    color: rgba(255,255,255,.85);
}

/* 댓글 등록 폼 */
.story-comment-form {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 16px;
    padding: 14px;
    border-radius: 12px;
    background:
            rgba(255,255,255,.03);
    border: 1px solid
            rgba(255,255,255,.06);
}

.story-comment-nickname-input {
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid
            rgba(255,255,255,.1);
    background:
            rgba(255,255,255,.05);
    color: white;
    font-size: 13px;
}

.story-comment-nickname-input::placeholder {
    color: rgba(255,255,255,.35);
}

.story-comment-content-input {
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid
            rgba(255,255,255,.1);
    background:
            rgba(255,255,255,.05);
    color: white;
    font-size: 13px;
    min-height: 80px;
    resize: vertical;
}

.story-comment-content-input::placeholder {
    color: rgba(255,255,255,.35);
}

.story-comment-submit-button {
    align-self: flex-end;
    border: none;
    border-radius: 8px;
    padding: 8px 16px;
    font-size: 13px;
    background: #4caf50;
    color: white;
    cursor: pointer;
}

/* 댓글 리스트 */
.story-comment-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.story-comment-item {
    border: 1px solid
            rgba(255,255,255,.06);
    border-radius: 10px;
    padding: 10px 12px;
    background:
            rgba(255,255,255,.03);
}

.story-comment-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
}

.story-comment-nickname {
    font-weight: 600;
    font-size: 13px;
    color: white;
}

.story-comment-date {
    font-size: 11px;
    color: #999;
}

.story-comment-content {
    margin: 0 0 8px;
    font-size: 13px;
    white-space: pre-wrap;
    word-break: break-word;
    color: rgba(255,255,255,.85);
}

.story-comment-actions {
    display: flex;
    justify-content: flex-end;
}

.story-comment-delete-button {
    border: none;
    border-radius: 6px;
    padding: 4px 10px;
    font-size: 11px;
    background: #ff4d67;
    color: white;
    cursor: pointer;
}

.story-comment-empty {
    font-size: 12px;
    color: #999;
}

/* 수정 모달 */
.story-modal-overlay {
    position: fixed;
    inset: 0;
    background:
            rgba(0,0,0,.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99999;
}

.story-modal-box {
    width: 680px;
    max-width: 95vw;
    padding: 24px;
    border-radius: 20px;
    background: #111;
}

.story-modal-title {
    color: white;
    margin-bottom: 16px;
}

.story-modal-textarea {
    width: 100%;
    min-height: 200px;
    padding: 14px;
    border-radius: 12px;
    border: 1px solid
            rgba(255,255,255,.1);
    background:
            rgba(255,255,255,.05);
    color: white;
    resize: vertical;
}

.story-modal-buttons {
    margin-top: 14px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.story-modal-save-button {
    background: #4caf50;
    color: white;
    border: none;
    border-radius: 8px;
    padding: 8px 16px;
    cursor: pointer;
}

.story-modal-cancel-button {
    background: #bdbdbd;
    color: #333;
    border: none;
    border-radius: 8px;
    padding: 8px 16px;
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/AppStoryManage.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB;gCAC4B;IAC5B;iCAC6B;IAC7B,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB;;;;;aAKS;IACT,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB;iCAC6B;IAC7B;;;;;;aAMS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;;;IAGI,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,UAAU;AACV;IACI,gBAAgB;IAChB,iBAAiB;IACjB;iCAC6B;AACjC;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB;iCAC6B;IAC7B;iCAC6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB;gCAC4B;IAC5B;iCAC6B;IAC7B,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB;gCAC4B;IAC5B;iCAC6B;IAC7B,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,eAAe;AACnB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI;iCAC6B;IAC7B,mBAAmB;IACnB,kBAAkB;IAClB;iCAC6B;AACjC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,eAAe;IACf,qBAAqB;IACrB,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA,UAAU;AACV;IACI,eAAe;IACf,QAAQ;IACR;0BACsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB;gCAC4B;IAC5B;iCAC6B;IAC7B,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB","sourcesContent":["/* 파일명: AppStoryManage.css */\n\n.story-manage {\n    width: 100%;\n}\n\n.story-manage-title {\n    color: white;\n    margin-bottom: 24px;\n}\n\n/* 이야기 등록 */\n.story-form {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-bottom: 24px;\n}\n\n.story-textarea {\n    width: 100%;\n    min-height: 100px;\n    padding: 14px;\n    border-radius: 12px;\n    border: 1px solid\n            rgba(255,255,255,.1);\n    background:\n            rgba(255,255,255,.05);\n    color: white;\n    resize: vertical;\n}\n\n.story-save-button {\n    height: 48px;\n    border: none;\n    border-radius: 12px;\n    background:\n            linear-gradient(\n                    135deg,\n                    #6f3cff,\n                    #2d9cff\n            );\n    color: white;\n    font-size: 14px;\n    cursor: pointer;\n}\n\n/* 이야기 리스트 */\n.story-list {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.story-card {\n    padding: 20px;\n    border-radius: 20px;\n    background:\n            rgba(255,255,255,.04);\n    border:\n            1px solid rgba(\n                    255,\n                    255,\n                    255,\n                    .08\n            );\n}\n\n.story-header {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.story-content-text {\n    white-space: pre-wrap;\n    word-break: break-word;\n    color: rgba(255,255,255,.9);\n    font-size: 14px;\n    line-height: 1.5;\n}\n\n.story-actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n}\n\n.story-edit-button,\n.story-delete-button,\n.story-comment-button {\n    border: none;\n    border-radius: 10px;\n    padding: 8px 14px;\n    font-size: 13px;\n    color: white;\n    cursor: pointer;\n}\n\n.story-edit-button {\n    background: #2d9cff;\n}\n\n.story-delete-button {\n    background: #ff4d67;\n}\n\n.story-comment-button {\n    background: #ff9800;\n}\n\n/* 댓글 영역 */\n.story-comment-section {\n    margin-top: 14px;\n    padding-top: 12px;\n    border-top: 1px solid\n            rgba(255,255,255,.08);\n}\n\n.story-comment-title {\n    font-size: 14px;\n    margin-bottom: 10px;\n    color: rgba(255,255,255,.85);\n}\n\n/* 댓글 등록 폼 */\n.story-comment-form {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-bottom: 16px;\n    padding: 14px;\n    border-radius: 12px;\n    background:\n            rgba(255,255,255,.03);\n    border: 1px solid\n            rgba(255,255,255,.06);\n}\n\n.story-comment-nickname-input {\n    padding: 10px 12px;\n    border-radius: 8px;\n    border: 1px solid\n            rgba(255,255,255,.1);\n    background:\n            rgba(255,255,255,.05);\n    color: white;\n    font-size: 13px;\n}\n\n.story-comment-nickname-input::placeholder {\n    color: rgba(255,255,255,.35);\n}\n\n.story-comment-content-input {\n    padding: 10px 12px;\n    border-radius: 8px;\n    border: 1px solid\n            rgba(255,255,255,.1);\n    background:\n            rgba(255,255,255,.05);\n    color: white;\n    font-size: 13px;\n    min-height: 80px;\n    resize: vertical;\n}\n\n.story-comment-content-input::placeholder {\n    color: rgba(255,255,255,.35);\n}\n\n.story-comment-submit-button {\n    align-self: flex-end;\n    border: none;\n    border-radius: 8px;\n    padding: 8px 16px;\n    font-size: 13px;\n    background: #4caf50;\n    color: white;\n    cursor: pointer;\n}\n\n/* 댓글 리스트 */\n.story-comment-list {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.story-comment-item {\n    border: 1px solid\n            rgba(255,255,255,.06);\n    border-radius: 10px;\n    padding: 10px 12px;\n    background:\n            rgba(255,255,255,.03);\n}\n\n.story-comment-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 4px;\n}\n\n.story-comment-nickname {\n    font-weight: 600;\n    font-size: 13px;\n    color: white;\n}\n\n.story-comment-date {\n    font-size: 11px;\n    color: #999;\n}\n\n.story-comment-content {\n    margin: 0 0 8px;\n    font-size: 13px;\n    white-space: pre-wrap;\n    word-break: break-word;\n    color: rgba(255,255,255,.85);\n}\n\n.story-comment-actions {\n    display: flex;\n    justify-content: flex-end;\n}\n\n.story-comment-delete-button {\n    border: none;\n    border-radius: 6px;\n    padding: 4px 10px;\n    font-size: 11px;\n    background: #ff4d67;\n    color: white;\n    cursor: pointer;\n}\n\n.story-comment-empty {\n    font-size: 12px;\n    color: #999;\n}\n\n/* 수정 모달 */\n.story-modal-overlay {\n    position: fixed;\n    inset: 0;\n    background:\n            rgba(0,0,0,.7);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 99999;\n}\n\n.story-modal-box {\n    width: 680px;\n    max-width: 95vw;\n    padding: 24px;\n    border-radius: 20px;\n    background: #111;\n}\n\n.story-modal-title {\n    color: white;\n    margin-bottom: 16px;\n}\n\n.story-modal-textarea {\n    width: 100%;\n    min-height: 200px;\n    padding: 14px;\n    border-radius: 12px;\n    border: 1px solid\n            rgba(255,255,255,.1);\n    background:\n            rgba(255,255,255,.05);\n    color: white;\n    resize: vertical;\n}\n\n.story-modal-buttons {\n    margin-top: 14px;\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n}\n\n.story-modal-save-button {\n    background: #4caf50;\n    color: white;\n    border: none;\n    border-radius: 8px;\n    padding: 8px 16px;\n    cursor: pointer;\n}\n\n.story-modal-cancel-button {\n    background: #bdbdbd;\n    color: #333;\n    border: none;\n    border-radius: 8px;\n    padding: 8px 16px;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
